module.exports = __webpack_public_path__ + "static/media/search_empty_img.391ea9ba.png";